import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import UserContext from "../context/UserContext";

const NavBar = () => {
  const { user, Logout } = useContext(UserContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = () => {
    Logout();
    closeMenu();
  };

  return (
    <nav className="relative border-b border-white/10 bg-slate-900/80 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="text-lg font-semibold tracking-tight text-white" onClick={closeMenu}>
          Finanzas Pro
        </Link>

        {user && (
          <>
            <button
              type="button"
              onClick={() => setIsMenuOpen((open) => !open)}
              aria-label="Abrir menú"
              className="inline-flex items-center rounded-md border border-white/10 p-2 text-slate-200 sm:hidden"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            <div className="hidden items-center gap-4 text-sm text-slate-300 sm:flex">
              <Link to="/" className="transition hover:text-white" onClick={closeMenu}>
                Dashboard
              </Link>
              <Link to="/transactions" className="transition hover:text-white" onClick={closeMenu}>
                Transacciones
              </Link>
              <Link to="/categories" className="transition hover:text-white" onClick={closeMenu}>
                Categorías
              </Link>
              <Link to="/reports" className="transition hover:text-white" onClick={closeMenu}>
                Reportes
              </Link>
              <button
                onClick={handleLogout}
                className="rounded-md border border-white/10 px-3 py-1.5 transition hover:bg-white/10"
              >
                Cerrar Sesión
              </button>
            </div>
          </>
        )}
      </div>

      {user && isMenuOpen && (
        <div className="border-t border-white/10 bg-slate-900/95 shadow-lg shadow-black/20 sm:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:px-6">
            <Link to="/" className="rounded-lg px-2 py-2 text-sm text-slate-200 transition hover:bg-white/10" onClick={closeMenu}>
              Dashboard
            </Link>
            <Link to="/transactions" className="rounded-lg px-2 py-2 text-sm text-slate-200 transition hover:bg-white/10" onClick={closeMenu}>
              Transacciones
            </Link>
            <Link to="/categories" className="rounded-lg px-2 py-2 text-sm text-slate-200 transition hover:bg-white/10" onClick={closeMenu}>
              Categorías
            </Link>
            <Link to="/reports" className="rounded-lg px-2 py-2 text-sm text-slate-200 transition hover:bg-white/10" onClick={closeMenu}>
              Reportes
            </Link>
            <button
              onClick={handleLogout}
              className="rounded-lg border border-white/10 px-2 py-2 text-left text-sm text-slate-200 transition hover:bg-white/10"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
